import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Excursii from "@/components/sections/Excursii";
import RoutesPrices from "@/components/sections/RoutesPrices";
import Testimonials from "@/components/sections/Testimonials";
import Booking from "@/components/sections/Booking";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import FloatingWhatsApp from "@/components/sections/FloatingWhatsApp";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-slate-950">
      <Navbar />
      <main>
        <Hero />
        <About />
        <RoutesPrices />
        <Testimonials />
        <Excursii />
        <Booking />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
